import { useApiIsLoaded, useMap } from "@vis.gl/react-google-maps"
import React from "react"

export const useGoogleMapsEffect = (mapId: string, callback: () => void, deps: any[]) => {
  const gMap = useMap(mapId)
  const apiIsLoaded = useApiIsLoaded()
  React.useEffect(() => {
    if (gMap && apiIsLoaded) {
      return callback()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gMap, apiIsLoaded, ...deps])
}
